import React, { ChangeEventHandler } from 'react';

export interface TextInputProps {
  value?: string | null;
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  invalid?: boolean;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
  className?: string;
  theme?: 'dark' | 'light';
  type?: 'text' | 'email' | 'textarea' | 'password' | 'date';
  [key: string]: any;
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  invalid = false,
  placeholder = 'Enter text',
  id = 'value',
  disabled = false,
  className = '',
  theme = 'dark',
  type = 'text',
  ...rest
}) => {
  const themeStyles =
    theme === 'dark'
      ? 'bg-gray-700 placeholder-gray-450 text-white focus:ring-white'
      : 'bg-gray-450 bg-opacity-25 focus:ring-black placeholder-gray-450 text-black';

  const props = () => {
    return {
      id,
      name: id,
      value: value ?? '',
      onChange,
      disabled,
      className: `form-input p-4 block w-full sm:text-sm sm:leading-5 border-none focus:border-none rounded-3xl shadow-sm ring-1 transition duration-500 ease-in-out focus:outline-none disabled:opacity-75 ${themeStyles} ${
        invalid ? 'ring-red-600' : 'ring-transparent'
      } ${className}`,
      placeholder,
      ...rest,
    };
  };

  if (type === 'textarea') return <textarea {...props()} rows={4} />;
  return <input type={type} {...props()} />;
};

export default TextInput;
